<div class="tml-tpl-wrap">
    <tam-column-panel [data]="config" [config]="briefConfig">
        <ng-template #bar let-dataItem="dataItem" let-index="index">
            <div [ngClass]="{'control-border':dataItem.sectionName === sectionName}" class="section-background">
                <label class="template-label" (click)="clickSection($event,dataItem.sectionName)"
                    [ngClass]="{'template-section-select':dataItem.sectionName === sectionName}">
                    <smart-icon name="multi-line" class="multi-line"></smart-icon>
                    {{dataItem.sectionName}}
                </label>
                <div *ngIf="dataItem.isExpandSection">
                    <div class="tml-tpl-row" *ngFor="let rowlabel of dataItem.container">
                        <div class="tml-tpl-cell" *ngFor="let ctrl of rowlabel">
                            <tam-template-base-layout [childConfig]="ctrl"></tam-template-base-layout>
                        </div>
                    </div>
                    <div *ngIf="dataItem.container.length ===0" class="flex-no-config">
                        <span>Currently Not Configurable</span>
                    </div>
                </div>
            </div>
        </ng-template>
    </tam-column-panel>
</div>